<template>
  <div
    class="like-btn"
    @click="handleLike()"
    :style="isLike ? setBg(likedIco) : setBg(unLikeIco)"
  ></div>
</template>

<script lang="ts" setup>
import { setBg, debounce } from "@utiles/index";
const props = defineProps({
  isLike: {
    type: Boolean,
    required: false,
    default: false,
  },
  unLikeIco: {
    default: "",
  },
  likedIco: {
    default: "",
  },
});
const emits = defineEmits(["cancelLike", "like"]);

const handleLike = debounce(() => {
  props.isLike ? emits("cancelLike") : emits("like");
}, 500);
</script>
<style scoped lang="scss">
@import "@assets/scss/dimen.scss";
.like-btn {
  position: fixed;
  right: 20px;
  bottom: 196px;
  width: 83px;
  height: 83px;
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .like-btn {
    position: fixed;
    right: calc(20px / $pcRate);
    bottom: calc(196px / $pcRate);
    width: calc(83px / $pcRate);
    height: calc(83px / $pcRate);
  }
}
</style>
